import React, { useMemo } from "react";

import { formatNumericCurrency, useTranslation } from "utils";

import { CurrencyCode } from "consts";

import { Flex, KlimRadioGroup, RadioChangeEvent, Typography } from "components";

type PayoutOption = {
  label: string;
  value: boolean;
  payout: string;
};

type CustomKlimRadioGroupWithPayoutsProps = {
  value: boolean | null;
  currency?: CurrencyCode;
  onChange: (e: RadioChangeEvent) => void;
  className?: string;
  dataTestId?: string;
  residuePayout?: number | null;
  disabled: boolean;
};

export const CustomKlimRadioGroupWithPayouts = ({
  value,
  onChange,
  className,
  dataTestId,
  residuePayout,
  disabled,
  currency,
}: CustomKlimRadioGroupWithPayoutsProps) => {
  const { t } = useTranslation(["modules", "allFieldView"]);

  const payoutOptions: PayoutOption[] = useMemo(
    () => [
      {
        label: "allFieldView:fertilizerForm.yes",
        value: true,
        payout: residuePayout
          ? `${t("allFieldView:fertilizerForm.upTo")} ${formatNumericCurrency(residuePayout, { currency, decimals: 0, signDisplay: "always" })}`
          : "",
      },
      {
        label: "allFieldView:fertilizerForm.no",
        value: false,
        payout: residuePayout ? formatNumericCurrency(0, { currency, decimals: 0 }) : "",
      },
    ],
    [residuePayout, currency, t]
  );

  return (
    <KlimRadioGroup
      type="tertiary"
      size="large"
      dataTestId={dataTestId}
      className={className}
      options={payoutOptions.map((option) => ({
        label: (
          <Flex vertical justify="space-around">
            <Typography variant="paragraph-m">{t(option.label)}</Typography>
            {typeof residuePayout === "number" && residuePayout !== null && (
              <Typography variant="paragraph-xs" color="grey-600">
                {option.payout}
              </Typography>
            )}
          </Flex>
        ),
        value: option.value,
      }))}
      value={value}
      optionType="button"
      buttonStyle="solid"
      onChange={onChange}
      disabled={disabled}
      fullWidth
    />
  );
};
